import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavParams, Platform, ToastController, IonContent, IonRouterOutlet } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { Preferences } from '@capacitor/preferences';
import { Observable, Subscription } from 'rxjs';
import { LoginPage } from '../login/login.page';
import { EmailValidationPage } from '../email-validation/email-validation.page';
import { PurchaseService } from 'src/app/services/purchase.service';
@Component({
  selector: 'app-survey',
  templateUrl: './survey.page.html',
  styleUrls: ['./survey.page.scss'],
  providers: [UtilService, UserService, NavParams, IonRouterOutlet]
})
export class SurveyPage implements OnInit {


  @ViewChild(IonContent) content: IonContent | any;

  public userData: any;
  // Radio is single choice. Checkbox is multiple choices: set max responses
  public form1 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 5, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form2 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 6, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form3 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 2, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form4 = {type:'checkbox', answers : [] as any, textField: null, answerSize: 6, answer: null, maxResponses: 2, preReq: [], preReqQuestion: -1 };
  public form5 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 8, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form6 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 5, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form7 = {type:'checkbox', answers : [] as any, textField: null, answerSize: 13, answer: null, maxResponses: 2, preReq: [], preReqQuestion: -1 };
  public form8 = {type:'text', answers : [] as any, textField: '', answerSize: 0, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form9 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 4, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form10 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 3, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form11 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 2, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };
  public form12 = {type:'radiobutton', answers : [] as any, textField: null, answerSize: 5, answer: null, maxResponses: 0, preReq: [], preReqQuestion: -1 };

  public step: number = 1;
  private isNative: boolean = true;
  private isAndroid: boolean = true;
  public showAlert: boolean = false;
  private skippedQuestions: boolean[] = [];

  //number of questions on survey
  public forms = [this.form1, this.form2, this.form3, this.form4, this.form5, this.form6, this.form7, this.form8, this.form9, this.form10, this.form11,
  this.form12];


  public backButton: Subscription|any;
  constructor(public platform: Platform,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public userService: UserService,
    public purchaseService: PurchaseService,
    public util: UtilService,
    public modalCtrl: ModalController) { 

    }

  ngOnInit() {
  }

  async ionViewWillEnter() {
    console.log('ionViewDidLoad SurveyPage');
    this.backButton =this.platform.backButton.subscribe(() => {
      this.back();
    });

    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: this.translate.instant('statisticalOnly'),
      buttons: ['Ok']
    });
    (await alert).present();

  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }

  ionViewDidEnter(){
    Preferences.get({key:'USER_DATA'}).then(async (val:any)=>{
      
      for(let formNumber: number=0; formNumber<this.forms.length; formNumber++){

        let aForm = this.forms[formNumber];
        for(let i: number=0;i<aForm.answerSize;i++){
          aForm.answers.push({label: 'A'+ (formNumber+1) +'-' + (i+1), value: false});
        }
  
        this.skippedQuestions[formNumber] = false;
    
      }
      
              
      this.isNative = this.util.isNative();
    
      this.platform.ready().then(() => {
    
        this.isAndroid = this.platform.is('android');
      });

      val = val.value ? JSON.parse(val.value) : null;
      if (val === null) {
        this.modalCtrl.create({component:LoginPage});
        return;
      } else if (val.needsEmailValidation) {
        let modal = this.modalCtrl.create({component:EmailValidationPage});

        (await modal).present();
        return;
      }
      this.userData = val;

      if (this.userData?.survey5Answers != undefined) {
        this.showModalAlert(this.translate.instant('alreadyDoneSurvey'));
        this.dismiss();

      } else {
        return;
      }

    });
  }



  back() {
    if (this.step == 1) {
      this.modalCtrl.dismiss('cancelled');
      // this.viewCtrl.dismiss('cancelled', null, { 'duration': environment.viewCtrlTimeout });
      return;
    }
    this.step--;

    if (this.skippedQuestions[this.step - 1]) {
      this.back();
    }


    this.scrollToTop();

  }

  private scrollToTop() {
    if (this.content && this.content.scrollToTop) {
      this.content.scrollToTop(300);
    }
  }

  async showModalAlert(message:any) {
    let alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        // {
        //   text: this.translate.instant('cancel'),
        //   handler: () => {
        //     console.log('cancel clicked');
        //     return;

        //   }
        // },
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }

  next() {
    let currentForm = this.forms[this.step - 1];

    console.log('this.forms: ' + JSON.stringify(this.forms));
    console.log('currentForm: ' + JSON.stringify(currentForm));

    if (currentForm.type == 'checkbox') {
      let foundTrueValue: number = 0;
      for (let i = 0; i < currentForm.answers.length; i++) {
        let anAnswer:any = currentForm.answers[i];
        if (anAnswer.value == true) {
          foundTrueValue++;
        }
      }
      if (foundTrueValue == 0) {
        this.showModalAlert(this.translate.instant('pleaseSelectResponse'));
        return;
      }
      if (currentForm.maxResponses != 0 && foundTrueValue > currentForm.maxResponses) {
        this.showModalAlert(this.translate.instant('pleaseSelectUpToResponses', { maxResponses: currentForm.maxResponses }));
        return;
      }
    } else if (currentForm.type == 'radiobutton') {
      if (currentForm.answer == undefined || currentForm.answer == null) {
        this.showModalAlert(this.translate.instant('pleaseSelectResponse'));
        return;
      }
    }


    if (this.step == 12) {
      // Send responses to server
      this.sendResponsesToServer();
      return;
    }


    this.goToNextStep();

    this.showAlert=false;
  }

  async sendResponsesToServer() {
    let loader = this.loadingCtrl.create({
      message: this.translate.instant('msgOneMomentPlease'),
    });
    (await loader).present();


    var theObs: Observable<any>;
    let responses: any = { responses: this.forms };

    theObs = this.userService.respondSurvey(this.userData, responses);

    theObs.subscribe(async data => {
      console.log('Survey: respondSurvey subscribe entered: ' + JSON.stringify(data));

      if (data === '{ok}') {
        this.userData.survey5Answers = responses;
        
        let coins: number = 0;
        if (this.userData?.coins != undefined && this.userData?.coins != null && this.userData?.coins != 0) {
          coins = this.userData?.coins;
        }
        coins += 10;
        this.userData.coins = coins;
        await Preferences.set({
          key: 'USER_DATA',
          value: JSON.stringify(this.userData)
        });
        (await loader).dismiss();
        let alert = this.alertCtrl.create({
          message: this.translate.instant('thanksForResponding'),
          subHeader: this.translate.instant('coinsCredited'),
          buttons: ['Ok']
        });
        (await alert).present();
        this.modalCtrl.dismiss(this.userData);
        return;
      } else {
        this.util.showToastUnableToConnect(this.toastCtrl);
        (await loader).dismiss();
        console.log('Survey: respondSurvey error: ' + JSON.stringify(data));
      }
    },
      async err => {
        this.util.showToastUnableToConnect(this.toastCtrl);
        (await loader).dismiss();
        console.log('Survey: respondSurvey error: ' + JSON.stringify(err));
      });
  }

  async radioSelected(answer: any) {
    console.log('The answer: ' + answer);

    if (this.isNative) {
      if (answer == 'A12-4' || answer == 'A12-5') {
        // rating at app store
        if (!this.showAlert){
          this.util.showAlertWouldYouRateUs();
          this.showAlert=true;
        }
      }
    }
    if(answer.includes('A1') || answer.includes('A5')) {
      if(answer == 'A1-5' || answer == 'A5-8') {
        this.forms[this.step-1].textField = '';
      } else {
        this.forms[this.step-1].textField = null;
      }
    }
  }

  goToNextStep() {

    if (this.step == 32) {
      // Send responses to server
      this.sendResponsesToServer();
      return;
    }


    // Check if has to skip
    this.step++;


    // Validate preReq
    let newForm = this.forms[this.step - 1];
    let previousAnswer = this.forms[newForm.preReqQuestion - 1];

    if (newForm.preReq.length > 0 && previousAnswer != undefined && previousAnswer.answer != null) {
      if (newForm.preReq.indexOf(previousAnswer.answer) == -1) {
        this.skippedQuestions[this.step - 1] = true;
        this.goToNextStep();
      }
    }

    this.scrollToTop();

    this.skippedQuestions[this.step - 1] = false;

  }

  swipeEvent(e:any) {
    try {
      console.log('swiped');
      if (e == undefined || e == null || e.deltaX < 0) {
        // slide left
        return;
      }
      console.log(JSON.stringify(e));
      this.back();

      // Check direction left to right
      // Check if works on other places this is opened
      // Can we have a better animation?
      //this.dismiss();

    } catch (error) {
      console.error(JSON.stringify(error), error);
    }
  }

  dismiss() {
    this.modalCtrl.dismiss('Left Survey');
  }



}
